import Logger from "../../../utils/Logger";
import WrapperMessageDispatcher from "../../../utils/WrapperMessageDispatcher";
const TAG = 'RouteFrameCollectionManagerUtils';
export default class RouteFrameCollectionManagerUtils {
    static locationChange(message, history) {
        Logger.debug(TAG, "Push url");
        history.push(message.url);
        WrapperMessageDispatcher.dispatchMessage('loaded');
    }
}
//# sourceMappingURL=RouteFrameCollectionManagerUtils.js.map